/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MyNetworkStatusResponse
 */
export interface MyNetworkStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MyNetworkStatusResponse
     */
    shouldWarn: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyNetworkStatusResponse
     */
    isVpn: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyNetworkStatusResponse
     */
    isTor: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyNetworkStatusResponse
     */
    isHostingProvider: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MyNetworkStatusResponse
     */
    isProxy: boolean;
    /**
     * 
     * @type {string}
     * @memberof MyNetworkStatusResponse
     */
    country?: string;
}

/**
 * Check if a given object implements the MyNetworkStatusResponse interface.
 */
export function instanceOfMyNetworkStatusResponse(value: object): value is MyNetworkStatusResponse {
    if (!('shouldWarn' in value) || value['shouldWarn'] === undefined) return false;
    if (!('isVpn' in value) || value['isVpn'] === undefined) return false;
    if (!('isTor' in value) || value['isTor'] === undefined) return false;
    if (!('isHostingProvider' in value) || value['isHostingProvider'] === undefined) return false;
    if (!('isProxy' in value) || value['isProxy'] === undefined) return false;
    return true;
}

export function MyNetworkStatusResponseFromJSON(json: any): MyNetworkStatusResponse {
    return MyNetworkStatusResponseFromJSONTyped(json, false);
}

export function MyNetworkStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyNetworkStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'shouldWarn': json['shouldWarn'],
        'isVpn': json['isVpn'],
        'isTor': json['isTor'],
        'isHostingProvider': json['isHostingProvider'],
        'isProxy': json['isProxy'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function MyNetworkStatusResponseToJSON(json: any): MyNetworkStatusResponse {
    return MyNetworkStatusResponseToJSONTyped(json, false);
}

export function MyNetworkStatusResponseToJSONTyped(value?: MyNetworkStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shouldWarn': value['shouldWarn'],
        'isVpn': value['isVpn'],
        'isTor': value['isTor'],
        'isHostingProvider': value['isHostingProvider'],
        'isProxy': value['isProxy'],
        'country': value['country'],
    };
}

